module.exports = __webpack_public_path__ + "img/findings.9991df57.svg";